import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import Sidebar from './lib/sidebar/Sidebar';
import Home from './pages/home';
import ScoutingSheet from './pages/scouting-sheet';
import { Providers } from './lib/providers/providers';

function App() {

    return (
      <Providers>
        <div className="h-100 w-100 bg-black" id="outer-container">
          <Router>
            <Sidebar papeWrapID={'page-warp'} outerContainerID={'outer-container'} />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/scouting" element={<ScoutingSheet />}/>
            </Routes>
          </Router>
        </div>
      </Providers>
    );
}

export default App;